<template>
  <v-card
    outlined
    class="pa-4 "
  >
    <!-- Titre principal -->
    <v-card-title class="font-weight-bold text-h6 text--primary pa-0 mb-4">
      {{ `${$t("Questionnaire de prise de contact avec l'auteur(e)")} ${author.full_name || ''}` }}
    </v-card-title>

    <v-card-text class="pa-0">
      <v-row>
        <v-col
          v-for="q in questionsList"
          :key="q.id"
          cols="12"
          md="6"
        >
          <v-card
            outlined
            class="fill-height rounded-lg pa-4 d-flex flex-column justify-space-between"
          >
            <div>
              <!-- En-tête : Titre du bloc -->
              <div class="d-flex align-center justify-space-between mb-3">
                <h3 class="text-subtitle-1 font-weight-medium grey--text text--dark-3">
                  {{ q.label }}
                </h3>
              </div>

              <!-- CAS 1 : Des données existent (Statut ou Texte) -->
              <template v-if="hasStatus(q.statusKey) || hasText(q.textKey)">

                <!-- Question Oui / Non -->
                <div
                  v-if="hasStatus(q.statusKey)"
                  class="mb-3"
                >
                  <div class="d-flex align-center flex-wrap">
                    <div class="text-caption font-weight-bold ">
                      {{ q.statusLabel }}
                    </div>
                    <v-chip
                      x-small
                      class="font-weight-bold ml-2"
                      :color="author[q.statusKey] ? 'success' : 'error'"
                    >
                      {{ author[q.statusKey] ? 'Oui' : 'Non' }}
                    </v-chip>
                  </div>
                </div>

                <!-- Sous-titre du texte (affiché UNIQUEMENT si du texte existe) -->
                <div
                  v-if="q.subLabel && hasText(q.textKey)"
                  class="text-caption font-weight-bold "
                >
                  {{ q.subLabel }}
                </div>

                <!-- Contenu texte HTML/Paragraphe -->
                <div
                  v-if="hasText(q.textKey)"
                  class="text-caption text--primary pl-1"
                  v-html="author[q.textKey]"
                ></div>

              </template>

              <!-- CAS 2 : Ni statut ni texte renseigné -->
              <div
                v-else
                class="text-body-2 text--disabled font-italic"
              >
                {{ $t('Non renseigné') }}
              </div>

            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'AuthorQuestionnaireOverview',

  props: {
    author: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    const questionsList = computed(() => {
      const authorName = (props.author && props.author.full_name) ? props.author.full_name : "l'auteur"

      return [
        {
          id: 'A',
          label: `À propos de ${authorName}`,
          subLabel: 'Présentation & vision de la promotion :',
          textKey: 'about_author',
        },
        {
          id: 'B',
          label: 'Connaissance de la promotion',
          statusKey: 'has_promotion_knowledge',
          statusLabel: "Avez-vous déjà participé à la promotion d'un livre :",
          subLabel: 'Actions mises en place et efficacité :',
          textKey: 'promotion_knowledge_actions',
        },
        {
          id: 'C',
          label: `Réseau de ${authorName}`,
          subLabel: 'Contacts et relais potentiels :',
          textKey: 'network',
        },
        {
          id: 'E',
          label: 'Qualité de la communication',
          statusKey: 'has_communication_knowledge',
          statusLabel: 'Aisance de communication :',
          subLabel: 'Motivations et précisions :',
          textKey: 'communication_knowledge_reason',
        },
        {
          id: 'F',
          label: "Plan d'action",
          subLabel: 'Plan d\'action proposé :',
          textKey: 'action_plans',
        },
        {
          id: 'G',
          label: 'Informations complémentaires',
          subLabel: 'Notes et informations complémentaires :',
          textKey: 'additionnal_informations',
        },
      ]
    })

    // Vérifie si la valeur boolean/status existe et n'est pas null/undefined
    const hasStatus = key => {
      return (
        Boolean(key) &&
        Boolean(props.author) &&
        props.author[key] !== undefined &&
        props.author[key] !== null
      )
    }

    // Vérifie si une chaîne de texte est présente et non vide
    const hasText = key => {
      return (
        Boolean(key) &&
        Boolean(props.author) &&
        props.author[key] !== undefined &&
        props.author[key] !== null &&
        String(props.author[key]).trim() !== ''
      )
    }

    return {
      questionsList,
      hasStatus,
      hasText,
    }
  },
}
</script>

<style scoped>


.custom-content :deep(p) {
  margin-bottom: 0.25rem;
}

.custom-content :deep(ul) {
  padding-left: 1.25rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.custom-content :deep(li) {
  margin-bottom: 0.25rem;
}
</style>
